import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import type { ChangePacketResponseCustomerPayload } from '@/types/packet-response'

export async function changePacketResponseCustomer(
  packetResponseId: string,
  payload: ChangePacketResponseCustomerPayload
) {
  await makePatchRequest(
    `${ApiBase}/packet_responses/${packetResponseId}/customer`,
    {
      body: JSON.stringify(payload),
    }
  )
}
